/**
 * Scrolls to the element with `id`, waiting a few frames for it to appear
 * (after a client-side navigation the page's chunk may still be loading).
 * Returns a cancel function. The fixed navbar is accounted for by the
 * target's `scroll-mt-*` class.
 */
export function scrollToId(id: string, behavior: ScrollBehavior = "auto", onMissing?: () => void) {
  let frames = 0;
  let raf = 0;
  const attempt = () => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior, block: "start" });
    } else if (++frames < 60) {
      raf = requestAnimationFrame(attempt);
    } else {
      onMissing?.();
    }
  };
  attempt();
  return () => cancelAnimationFrame(raf);
}
